import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueI18n from 'vue-i18n';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(VueI18n)
Vue.use(ElementUI);
Vue.config.productionTip = false;
// 准备翻译的语言环境信息
const messages = {
    'en-us': require('./assets/lang/en-us'),
    'zh-cn': require('./assets/lang/zh-cn')
}

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
    locale: 'zh-cn', // 设置地区
    messages, // 设置地区信息
})

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");